module.exports = __webpack_public_path__ + "static/media/banner-img-1.a5f6d867.png";